// function initSearchGridToggle() {
//     const layoutButtonsWrapper = document.querySelector('.mlveda-seach-grid-modify-buttons');
//     if (!layoutButtonsWrapper) return;

//     const layoutButtons = layoutButtonsWrapper.querySelectorAll('button.grid--button');
//     layoutButtons.forEach((button) => {
//         button.addEventListener('click', function () {
//             if (this.classList.contains('to_grid')) {
//                 sessionStorage.setItem('searchGridLayout', 'grid');
//             } else if (this.classList.contains('to_list')) {
//                 sessionStorage.setItem('searchGridLayout', 'list');
//             }
//             setSearchGridLayout();
//         });
//     });
//     setSearchGridLayout();
// }




// function setSearchGridLayout(){
//     const searchGridLayout = sessionStorage.getItem('searchGridLayout') || 'grid';

//     const productsGrid = document.querySelector('.mlveda-custom-sub-grid.products--grid');
//     // const products = productsGrid.querySelectorAll('.grid__item.grid-product');
    
//     if (!productsGrid) return;
//     if (searchGridLayout == 'list'){
//         productsGrid.classList.add("product_list_view");
//     }else{
//         productsGrid.classList.remove("product_list_view");
//     }
// }

// document.addEventListener('DOMContentLoaded', function () {
//     initSearchGridToggle();
// });
// document.addEventListener('shopify:section:load', function (event) {
//     // Only re-initialize if the updated section contains your wrapper
//     if (event.target.querySelector('.mlveda-seach-grid-modify-buttons')) {
//         initSearchGridToggle();
//     }
// });
// document.addEventListener('facet:updated', function () {
//     initSearchGridToggle();
// });
class SearchGridToggle extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.setup();
    }

    setup() {
        const buttons = this.querySelectorAll('button.grid--button');

        buttons.forEach(button => {
            button.removeEventListener('click', this.toggleHandler);
            button.addEventListener('click', this.toggleHandler.bind(this));
        });

        SearchGridToggle.applyGridLayout(); // apply on load
    }

    toggleHandler(event) {
        const button = event.currentTarget;

        if (button.classList.contains('to_grid')) {
            sessionStorage.setItem('searchGridLayout', 'grid');
        } else if (button.classList.contains('to_list')) {
            sessionStorage.setItem('searchGridLayout', 'list');
        }

        SearchGridToggle.applyGridLayout(); // apply after toggle
    }

    // Make applyGridLayout globally callable
    static applyGridLayout() {
        const layout = sessionStorage.getItem('searchGridLayout') || 'grid';
        const gridContainer = document.querySelector('.mlveda-custom-sub-grid.products--grid');

        if (!gridContainer) return;

        if (layout === 'list') {
            gridContainer.classList.add('product_list_view');
        } else {
            gridContainer.classList.remove('product_list_view');
        }
    }
}

customElements.define('search-grid-toggle', SearchGridToggle);


document.addEventListener('DOMContentLoaded', () => {
    const layout = sessionStorage.getItem('searchGridLayout') || 'grid';
    const gridContainer = document.querySelector('.mlveda-custom-sub-grid.products--grid');
    if (!gridContainer) return;

    if (layout === 'list') {
        gridContainer.classList.add('product_list_view');
    } else {
        gridContainer.classList.remove('product_list_view');
    }
});
